export default __webpack_public_path__ + "static/background-net-c37ca94c65f463b65cbc95b1bf0e81ae.png";